module.exports = __webpack_public_path__ + "img/bohui.d75bd6a3.png";